export default __webpack_public_path__ + "static/Comic-1f2c9edb37c54f2348bd40d5bfbae78c.webp";